import apiClient from './apiClient';
const base = '/admin/salary/danlon-deactivations';
const path = id => `${base}/${encodeURIComponent(id)}`;
const request = async operation => {
  try { return (await operation()).data.data; }
  catch (error) {
    const body = error.response?.data;
    const result = new Error(body?.error?.message || body?.message || error.message);
    result.code = body?.error?.code || body?.code;
    throw result;
  }
};
const danlonDeactivationService = {
  list: (year, month, signal) => request(() => apiClient.get(base, { params: { year, month }, signal })),
  start: (year, month, { requestId }) => request(() => apiClient.post(base, { requestId }, { params: { year, month }, timeout: 95000 })),
  get: (id, signal) => request(() => apiClient.get(path(id), { signal })),
  continue: (id, body = {}) => request(() => apiClient.post(`${path(id)}/continue`, body)),
  cancel: id => request(() => apiClient.post(`${path(id)}/cancel`, {})),
  closeBrowser: id => request(() => apiClient.post(`${path(id)}/close-browser`, {})),
  closeSession: id => request(() => apiClient.post(`/admin/salary/danlon-browser-sessions/${encodeURIComponent(id)}/end`, {})),
  frame: async (id, signal) => (await apiClient.get(`${path(id)}/frame`, { responseType: 'blob', signal, headers: { 'Cache-Control': 'no-store' } })).data,
  input: async (id, input) => { await apiClient.post(`${path(id)}/input`, input); },
};
export default danlonDeactivationService;
